import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-base-reservation-data',
  templateUrl: './base-reservation-data.component.html',
  styleUrls: ['./base-reservation-data.component.scss']
})
export class BaseReservationDataComponent implements OnInit {

  @Input() reservation:any;
  constructor() { }

  ngOnInit() {
  }

}
